import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { api } from '@/lib/api'

export interface CommunityPrompt {
  queryText: string
  queryType: string
  sourceUrls: string[]
}

export interface CommunityPromptsResponse {
  prompts: CommunityPrompt[]
  source: 'cache' | 'empty'
  refreshedAt: string | null
  stale: boolean
  canRefresh: true
}

export interface CommunityPromptsRefreshResponse {
  prompts: CommunityPrompt[]
  source: 'content-llm' | 'cache' | 'empty'
  refreshedAt: string | null
  charged: number
}

export function useCommunityPrompts(websiteId: string | null, enabled: boolean) {
  return useQuery({
    queryKey: ['community-prompts', websiteId],
    queryFn: () =>
      api.get<CommunityPromptsResponse>(
        `/api/prompts/community${websiteId ? `?website_id=${websiteId}` : ''}`
      ),
    enabled,
  })
}

export function useRefreshCommunityPrompts(websiteId: string | null) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: () => api.post<CommunityPromptsRefreshResponse>('/api/prompts/community/refresh', { website_id: websiteId }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['community-prompts', websiteId] })
    },
  })
}
